import type { PiniaColadaOptions } from "@pinia/colada";
import { PiniaColadaQueryHooksPlugin } from "@pinia/colada";
import { PiniaColadaAutoRefetch } from "@pinia/colada-plugin-auto-refetch";

function getContextFromQueryKey(key: readonly unknown[]): string {
  const keyStr = String(key[0]);

  if (keyStr.includes("teams"))
    return "team";
  if (keyStr.includes("identities"))
    return "page";
  if (keyStr.includes("identityItems"))
    return "page";
  if (keyStr.includes("events"))
    return "event";
  return "page"; // default context
}

function is404Error(error: any): boolean {
  if (error?.statusCode === 404 || error?.status === 404 || error?.response?.status === 404) {
    return true;
  }

  const notFoundCodes = [
    "ERR404TM00", // Team not found
    "ERR404ID00", // Identity not found
    "ERR404EV00", // Event not found
    "ERR404US00", // User not found
    "ERR404PV00", // PPV not found
  ];

  if (notFoundCodes.includes(error?.code)) {
    return true;
  }

  return error?.code?.includes?.("404")
    || error?.message?.toLowerCase?.().includes("not found");
}

export default {
  plugins: [
    PiniaColadaQueryHooksPlugin({
      onError: (error, entry) => {
        const context = getContextFromQueryKey(entry.key);

        if (is404Error(error)) {
          console.warn(`404 Error [${context}]:`, entry.key, (error as any)?.message || (error as any)?.code);

          showError({
            statusCode: 404,
            data: { context },
          });
          return;
        }

        console.warn(`Query failed [${context}]:`, entry.key, error);
      },
    }),
    PiniaColadaAutoRefetch({
      autoRefetch: false,
    }),
  ],
  queryOptions: {
    gcTime: 300_000, // 5 minutes
    staleTime: 60_000, // 1 minute - data becomes stale after 1 minute
  },
} satisfies PiniaColadaOptions;
